(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header1"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-pdp-development"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ld-ink-reveal'))customElements.define('ld-ink-reveal',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.input=this.querySelector('input');this.input?.addEventListener('input',()=>this.style.setProperty('--reveal',`${this.input.value}%`),{signal:this.abort.signal})}disconnectedCallback(){this.abort?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ld-review-pages')) {
  customElements.define('ld-review-pages', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      this.pages = Math.ceil(this.cards.length / 5);
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.counter = this.querySelector('[data-review-page]');
      const nav = this.querySelector('[data-review-nav]');
      if (nav) nav.hidden = this.pages <= 1;
      this.onClick = event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button === this.prev) this.show(this.page - 1);
        else if (button === this.next) this.show(this.page + 1);
        else if (button.matches('[data-review-expand]')) {
          const text = button.closest('[data-review-card]').querySelector('[data-review-text]');
          text.dataset.expanded = 'true';
          text.classList.remove('is-collapsed');
          button.setAttribute('aria-expanded', 'true');
          button.hidden = true;
        }
      };
      this.addEventListener('click', this.onClick);
      this.scheduleMeasure = () => {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => {
          if (this.ready && this.isConnected) this.measure();
        });
      };
      window.addEventListener('resize', this.scheduleMeasure);
      if (typeof ResizeObserver !== 'undefined') {
        const widths = new WeakMap();
        this.observer = new ResizeObserver(entries => {
          if (entries.some(entry => {
            const width = entry.contentRect.width;
            if (widths.get(entry.target) === width) return false;
            widths.set(entry.target, width);
            return true;
          })) this.scheduleMeasure();
        });
        this.cards.forEach(card => this.observer.observe(card.querySelector('[data-review-text]')));
      }
      if (document.fonts) {
        const schedule = this.scheduleMeasure;
        document.fonts.ready.then(() => {
          if (this.ready && this.scheduleMeasure === schedule) schedule();
        });
        document.fonts.addEventListener('loadingdone', this.scheduleMeasure);
      }
      this.show(this.page || 0);
    }
    show(page) {
      this.page = Math.max(0, Math.min(this.pages - 1, page));
      this.cards.forEach((card, index) => {
        card.hidden = index < this.page * 5 || index >= (this.page + 1) * 5;
        if (card.hidden) card.querySelector('[data-review-text]').dataset.expanded = 'false';
      });
      if (this.prev) this.prev.disabled = this.page === 0;
      if (this.next) this.next.disabled = this.page >= this.pages - 1;
      if (this.counter) this.counter.textContent = `${this.page + 1} / ${this.pages}`;
      this.scheduleMeasure();
    }
    measure() {
      this.cards.forEach(card => {
        if (card.hidden) return;
        const text = card.querySelector('[data-review-text]');
        const button = card.querySelector('[data-review-expand]');
        text.classList.add('is-collapsed');
        const truncated = text.clientHeight > 0 && text.scrollHeight > text.clientHeight + 1;
        const expanded = truncated && text.dataset.expanded === 'true';
        if (!truncated || expanded) text.classList.remove('is-collapsed');
        if (!truncated) text.dataset.expanded = 'false';
        button.hidden = !truncated || expanded;
        button.setAttribute('aria-expanded', String(expanded));
      });
    }
    disconnectedCallback() {
      this.ready = false;
      cancelAnimationFrame(this.measureFrame);
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.scheduleMeasure);
      document.fonts?.removeEventListener('loadingdone', this.scheduleMeasure);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('ld-pdp-gallery')) {
  customElements.define('ld-pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.ld-pdp-gallery__track');
      this.slides = [...this.querySelectorAll('[data-media-id]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.dialog = this.querySelector('dialog');
      this.index = 0;
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) {
          event.preventDefault();
          this.activateMedia(thumb.dataset.thumb);
        }
        if (event.target.closest('[data-prev]')) this.go(this.index - 1);
        if (event.target.closest('[data-next]')) this.go(this.index + 1);
        const zoom = event.target.closest('[data-zoom]');
        if (zoom && this.dialog?.showModal) {
          event.preventDefault();
          const image = this.querySelector('[data-zoom-image]');
          image.src = zoom.href;
          image.alt = zoom.querySelector('img')?.alt || '';
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
      }, { signal });
      this.track?.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const first = this.slides[0];
          if (!first) return;
          const position = this.track.scrollLeft;
          const nearest = this.slides.reduce((best, slide, index) => {
            const distance = Math.abs(slide.offsetLeft - first.offsetLeft - position);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          this.mark(nearest.index);
        });
      }, { signal, passive: true });
      this.addEventListener('keydown', (event) => {
        if (!event.target.matches('[data-thumb], .ld-pdp-gallery__track')) return;
        const actions = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in actions)) return;
        event.preventDefault();
        const next = Math.max(0, Math.min(actions[event.key], this.slides.length - 1));
        this.go(next);
        if (event.target.matches('[data-thumb]')) this.thumbs[next]?.focus({ preventScroll: true });
      }, { signal });
      this.resize = new ResizeObserver(() => this.go(this.index, 'instant'));
      if (this.track) this.resize.observe(this.track);
      this.mark(0);
    }
    activateMedia(id) {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(id));
      if (index >= 0) this.go(index);
    }
    go(index, behavior) {
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      if (!this.slides[next]) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.slides[next].offsetLeft - this.slides[0].offsetLeft, behavior: behavior || (reduced ? 'instant' : 'smooth') });
      this.mark(next);
    }
    mark(index) {
      const changed = this.index !== index;
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.inert = i !== index;
        if (i !== index) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
          if (changed) {
            slide.querySelectorAll('iframe').forEach((frame) => {
              const url = new URL(frame.src, location.href);
              if (/^(www\.)?youtube(-nocookie)?\.com$/.test(url.hostname)) {
                frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), url.origin);
              } else if (url.hostname === 'player.vimeo.com') {
                frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), url.origin);
              }
            });
          }
        }
      });
      this.thumbs.forEach((thumb, i) => i === index ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
      const counter = this.querySelector('[data-current]');
      if (counter) counter.textContent = String(index + 1);
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === this.slides.length - 1;
      const thumb = this.thumbs[index];
      if (thumb && changed) {
        const strip = thumb.parentElement;
        strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: 'instant' });
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

if (!customElements.get('ld-pdp-rating')) {
  customElements.define('ld-pdp-rating', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.link = this.querySelector('.ld-pdp-rating__link');
      const refresh = () => {
        const source = this.dataset.ratingScope === 'store' ? null : this.querySelector('[data-rating-source] [data-number-of-reviews]');
        const count = Number(source?.dataset.numberOfReviews ?? this.dataset.count);
        const average = Math.min(5, Math.max(0, Number(source?.dataset.averageRating ?? this.dataset.average)));
        const valid = Number.isFinite(count) && count > 0 && Number.isFinite(average) && average > 0;
        this.link.hidden = !valid;
        const editor = this.querySelector('.ld-pdp-rating__editor');
        if (editor) editor.hidden = valid;
        if (!valid) return;
        const locale = document.documentElement.lang || 'pl';
        this.querySelector('[data-rating-average]').textContent = average.toLocaleString(locale, { maximumFractionDigits: 2 });
        this.querySelector('[data-rating-count]').textContent = count.toLocaleString(locale);
        this.querySelectorAll('.ld-pdp-rating__star').forEach((star, i) => {
          star.style.setProperty('--ld-fill', `${Math.max(0, Math.min(100, (average - i) * 100))}%`);
        });
      };
      refresh();
      const source = this.querySelector('[data-rating-source]');
      if (source) {
        this.observer = new MutationObserver(refresh);
        this.observer.observe(source, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
      }
      this.link.addEventListener('click', (event) => {
        const href = this.link.getAttribute('href');
        if (!href?.startsWith('#') || href.length < 2) return;
        let id;
        try { id = decodeURIComponent(href.slice(1)); } catch { return; }
        const target = document.getElementById(id) || (id === 'judgeme_product_reviews' ? document.querySelector('#judgeme_all_reviews_page, #judgeme_all_reviews_widget, .jdgm-review-widget, .jdgm-all-reviews-widget, .jdgm-all-reviews-page') : null);
        if (!target) return;
        event.preventDefault();
        let parent = target.parentElement;
        while (parent) {
          if (parent.tagName === 'DETAILS') parent.open = true;
          parent = parent.parentElement;
        }
        target.style.scrollMarginTop = '100px';
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        if (target.id) history.replaceState(null, '', '#' + encodeURIComponent(target.id));
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

if (!customElements.get('ld-pdp-controls')) {
  customElements.define('ld-pdp-controls', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.root = this.closest('product-info');
      this.bar = this.querySelector('.ld-pdp-sticky');
      this.button = this.querySelector('[data-sticky-submit]');
      this.label = this.querySelector('[data-sticky-label]');
      this.price = this.querySelector('[data-sticky-price]');
      this.mobile = matchMedia('(max-width: 989px)');
      this.original = this.root?.querySelector('[id^="ProductSubmitButton-"]');
      this.form = this.original?.form;
      if (!this.original || !this.form) return;
      const signal = this.abort.signal;
      this.spacer = document.createElement('div');
      this.spacer.className = 'ld-pdp-sticky-spacer';
      this.spacer.setAttribute('aria-hidden', 'true');
      document.body.append(this.spacer);
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.mobile.addEventListener('change', this.schedule, { signal });
      window.addEventListener('scroll', this.schedule, { signal, passive: true });
      window.addEventListener('resize', this.schedule, { signal, passive: true });
      this.root.addEventListener('change', this.schedule, { signal });
      this.root.addEventListener('invalid', () => {
        if (this.stickyClick) this.form.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, { signal, capture: true });
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.button.disabled) return;
        this.stickyClick = true;
        this.original.click();
        this.sync();
      }, { signal });
      this.root.addEventListener('click', (event) => {
        if (event.isTrusted && event.target.closest('[id^="ProductSubmitButton-"]')) this.stickyClick = false;
      }, { signal });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.original, { attributes: true, childList: true, subtree: true, characterData: true });
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.bar);
      this.intersection = new IntersectionObserver(this.schedule);
      this.intersection.observe(this.original);
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event.data;
          if (String(data?.sectionId) !== this.dataset.sectionId) return;
          this.variantId = String(data.variant.id);
          this.updateAvailability(data.variant.available, data.variant.id, data.variant.title);
          this.root.querySelector('ld-pdp-gallery')?.activateMedia(data.variant.featured_media?.id);
          const fresh = data.html?.querySelector('ld-pdp-controls');
          if (fresh) this.price.textContent = fresh.dataset.price;
          this.schedule();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (!this.stickyClick || String(event.productVariantId) !== String(this.form.elements.namedItem('id')?.value)) return;
          this.original.scrollIntoView({ block: 'center', behavior: 'smooth' });
          this.stickyClick = false;
        }));
      }
      this.variantId = this.dataset.variantId;
      this.updateAvailability(this.dataset.available === 'true', this.dataset.variantId, this.dataset.variantTitle);
      this.sync();
    }
    updateAvailability(available, id, title) {
      this.root.querySelectorAll('[data-product-purchase]').forEach((node) => {
        node.dataset.productAvailable = String(Boolean(available));
      });
      this.root.querySelectorAll('[data-restock-trigger]').forEach((node) => {
        node.hidden = Boolean(available) || !id;
        node.dataset.restockVariantId = id || '';
        node.dataset.restockVariantTitle = title || '';
      });
    }
    sync() {
      if (!this.original?.isConnected) return;
      const idInput = this.form.elements.namedItem('id');
      const hasVariant = Boolean(idInput?.value) && !idInput.disabled;
      if (!idInput?.value) {
        this.price.textContent = '';
        this.updateAvailability(false, '', '');
      }
      const busy = this.original.getAttribute('aria-disabled') === 'true' || this.original.classList.contains('loading');
      const disabled = this.original.disabled || busy || !hasVariant;
      this.button.disabled = disabled;
      this.button.setAttribute('aria-busy', String(busy));
      this.label.textContent = disabled ? (this.original.querySelector('span')?.textContent || this.original.textContent).trim() : (this.button.dataset.label || this.original.querySelector('span')?.textContent || '').trim();
      const allowed = this.mobile.matches ? this.dataset.stickyMobile === 'true' : this.dataset.stickyDesktop === 'true';
      const visible = allowed && this.original.getBoundingClientRect().bottom < 0;
      this.bar.hidden = !visible;
      if (this.spacer) this.spacer.style.height = visible ? `${this.bar.getBoundingClientRect().height}px` : '0px';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      cancelAnimationFrame(this.frame);
      this.spacer?.remove();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
